import AlarmPushPresenter from "./alarm-push-presenter";

type Props = {};

const AlarmPushContainer = <P extends Props>(props: P) => {
  return <AlarmPushPresenter />;
};

export default AlarmPushContainer;
